// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1Zap2","description":"PatientConsentPreview_description__3ENW8"};